import { useEffect, useRef, useState } from 'react';
import { isMobile } from "react-device-detect";
import { useForm } from 'react-hook-form';
import { Link, useHistory } from 'react-router-dom';
import { checkCouponProduct, getUserCoupons } from '../apis/coupons';
import { iamportOrderStart } from "../apis/iamport";
import {
  getCouponDiscountPrice,
  getOrders
} from '../apis/orders';
import { getUserAddresses, getUserInfo } from '../apis/user';
import { AddressPopUp } from '../components/AddressPopUp';
import { Button } from '../components/Button';
import { Checkbox } from '../components/Checkbox';
import { DirectoryBar } from '../components/DirectoryBar';
import { H6 } from '../components/H6';
import { Icon } from '../components/Icon';
import { CouponPopUp } from '../components/MyPage/CouponPopUp';
import { PhoneNumber } from '../components/PhoneNumber';
import { PostPopUp } from '../components/PostPopUp';
import { Section } from '../components/Section';
import { Select } from '../components/Select';
import { TextField } from '../components/TextField';
import { BRAZE_EVENT } from '../constants/braze';
import { useUserDispatch, useUserState } from '../context/UserContext';
import { Bridge } from '../plugins/bridge';
import { nToast } from '../plugins/reactToast';
import { OrderStartV2Dto, PayStartResultV2Dto } from "../types/iamport";
import {
  CouponApplyResult, OrderProduct, OrderReady, UserAddress,
  ViewUserCouponDto
} from '../types/types';
import { addressSort } from "../utils/addressSort";
import makeKCPGoodInfo from '../utils/makeKCPGoodInfo';
import { payCode } from "../utils/payCode";
import { payMethodCode } from '../utils/payMethod';
import {getPG} from "../utils/getPG";
import moment from 'moment';
import {products} from "../dummies";

export const CartPaymentPage = () => {
  const history = useHistory();
  const [popup, setPopup] = useState(false);
  const [postModal, setPostModal] = useState<boolean>(false);
  const [discountType, setDiscountType] = useState('');
  const [couponPopup, setCouponPopup] = useState(false);
  const [payInfo, setPayInfo] = useState<OrderReady>();
  const [isNewAddress, setIsNewAddress] = useState<boolean>(true);
  const [agreement, setAgreement] = useState<{ order: boolean; third: boolean; }>({
    order: false,
    third: false,
  });
  const form = useForm<OrderStartV2Dto>();
  const [addresses, setAddresses] = useState<UserAddress[]>([]);
  const [coupons, setCoupons] = useState<ViewUserCouponDto[]>([]);
  const [couponDiscounted, setCouponDiscounted] = useState<CouponApplyResult>();
  const [usedCouponCode, setUsedCouponCode] = useState<string>('');
  const { isLoggedIn, userInfo } = useUserState();
  const userDispatch = useUserDispatch();
  const mounted = useRef(false);
  const [shippingRequestUserInput, setShippingRequestUserInput] = useState<boolean>(false);
  const [earnedMileage, setEarnedMileage] = useState<number>(0);

  useEffect(() => {
    if (!mounted.current) mounted.current = true;
    else {
      var total_product = 0;
      var orderEventProperties = payInfo?.products.map(product => {
        total_product += product.count;
        return {
          item_id: String(product.productId),
          item_name: product.productName,
          item_category: '?',
          item_color: product.color,
          item_gender: '?',
          item_size: product.sizeName,
          item_price: product.initialUnitPrice,
          item_discount_rate: ((product.initialUnitPrice - product.unitPrice) / product.initialUnitPrice) * 100,
          item_discount_price: product.unitPrice,
          order_item_quantity: 0
        };
      });
      //중복 제거
      var temp = orderEventProperties?.filter((src_item, index, array) => array.findIndex(tmp_item => tmp_item.item_id == src_item.item_id && tmp_item.item_size == src_item.item_size) == index);
      temp?.forEach(src_item => {
        orderEventProperties?.forEach(tmp_item => {
          if (src_item.item_id == tmp_item.item_id && src_item.item_size == tmp_item.item_size) {
            src_item.order_item_quantity++;
          }
        });
      });

      Bridge.sendAmplitude('order_initialized', {
        non_member_order: isLoggedIn ? false : true,
        item_id: temp?.map((item) => { return item.item_id; }),
        item_name: temp?.map((item) => { return item.item_name; }),
        item_category: temp?.map(() => { return '?'; }),
        item_color: temp?.map((item) => { return item.item_color; }),
        item_gender: temp?.map((item) => { return '?'; }),
        item_size: temp?.map((item) => { return item.item_size; }),
        item_price: temp?.map((item) => { return item.item_price; }),
        item_discount_rate: temp?.map((item) => { return item.item_discount_rate; }),
        item_discount_price: temp?.map((item) => { return item.item_discount_price; }),
        order_item_quantity: temp?.map((item) => { return item.order_item_quantity; }),
        total_order_item_quantity: total_product
      });

      Bridge.sendBraze(BRAZE_EVENT.ORDER_INITIALIZED, {
        non_member_order: isLoggedIn ? false : true,
        item_id: temp?.map((item) => { return item.item_id; }).join(','),
        item_name: temp?.map((item) => { return item.item_name; }).join(','),
        item_category: temp?.map(() => { return '?'; }).join(','),
        item_color: temp?.map((item) => { return item.item_color; }).join(','),
        item_gender: temp?.map((item) => { return '?'; }).join(','),
        item_size: temp?.map((item) => { return item.item_size; }).join(','),
        item_price: temp?.map((item) => { return item.item_price; }).join(','),
        item_discount_rate: temp?.map((item) => { return item.item_discount_rate; }).join(','),
        item_discount_price: temp?.map((item) => { return item.item_discount_price; }).join(','),
        order_item_quantity: temp?.map((item) => { return item.order_item_quantity; }).join(','),
        total_order_item_quantity: total_product
      });
    }
  }, [payInfo]);

  useEffect(() => {
    isLoggedIn && getUserInfo().then(r => userDispatch({ type: 'LOGIN', payload: r.data.payload })).catch(e => console.log('user is not logged in'));
    getOrders().then(r => {
      const data = r.data.payload;
      console.log(data)
      setPayInfo(data);
      form.setValue('usedCouponIds', []);
      form.setValue('payMethod', 'CARD');
    }).catch(e => console.log('getOrders e: ', e));
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      form.setValue('customerName', userInfo?.userName!);
      form.setValue('customerPhone', (userInfo?.userPhone!).replaceAll('-', ''));
    }
    isLoggedIn && getUserAddresses().then(r => {
      const adds = addressSort(r.data.payload);
      setAddresses(adds);
    }).catch(e => console.log('getUserAddresses e: ', e));
    isLoggedIn && getUserCoupons('USE_Y').then(r => {
        const data = r.data.payload.filter(coupon => coupon.issuedType !== 'DISCOUNT_KEY');
        setCoupons(data)
    }).catch(e => console.log('getUserCoupons e: ', e));
  }, [isLoggedIn]);
  useEffect(() => {
    if (addresses.length === 0) {
      setIsNewAddress(true);
    } else {
      setIsNewAddress(false);
    }
  }, [addresses]);

  useEffect(() => {
    isLoggedIn &&
      payInfo &&
      getCouponDiscountPrice(payInfo.orderNumber, {
        usingCouponCode: form.watch().usedCouponCode,
        usingMileage: form.watch().usedMileage,
        usingUserCouponIds: form.watch().usedCouponIds,
      })
        .then(r => {
              const totalDiscountedAmountByCoupon = r.data.payload.totalDiscountedAmountByCoupon
              const mileageCheck = (r.data.payload.finalTotalProductsPrice - r.data.payload.orderProducts.filter(product => product.unavailableMileage).reduce((sum, product) => sum + product.finalProductPrice , 0) )
              if(( (form.watch().usedCouponCode !== "" && form.watch().usedCouponCode !== undefined) || form.watch().usedCouponIds.length > 0)
                  && totalDiscountedAmountByCoupon <= 0
              ){
                nToast('할인 적용되는 상품이 없습니다.')
                setDiscountType('')
                resetCoupon()
              }else if(( (form.watch().usedCouponCode !== "" && form.watch().usedCouponCode !== undefined) || form.watch().usedCouponIds.length > 0)
                  && totalDiscountedAmountByCoupon > 0){
                nToast('쿠폰이 적용되었습니다.')
              }
              setCouponDiscounted(r.data.payload)
              setEarnedMileage(mileageCheck)
            }
        )
        .catch(e => resetCoupon());
  }, [
    isLoggedIn,
    form.watch().usedCouponIds,
    form.watch().usedCouponCode,
  ]);

  useEffect(() => {
    isLoggedIn &&
      payInfo &&
      getCouponDiscountPrice(payInfo.orderNumber, {
        usingCouponCode: form.watch().usedCouponCode,
        usingMileage: form.watch().usedMileage,
        usingUserCouponIds: form.watch().usedCouponIds,
      })
        .then(r => {
              const mileageCheck = (r.data.payload.finalTotalProductsPrice - r.data.payload.orderProducts.filter(product => product.unavailableMileage).reduce((sum, product) => sum + product.finalProductPrice , 0) )
              setCouponDiscounted(r.data.payload)
              setEarnedMileage(mileageCheck)
            }
        )
        .catch(e => resetCoupon());
  }, [form.watch().usedMileage])

  useEffect(() => {
    const defaultAddress =
      addresses.find(item => item.isDefault) || addresses[0];
    if (isNewAddress || !defaultAddress) {
      form.setValue('newUserAddress.addressName', '');
      form.resetField('newUserAddress');
      form.resetField('userAddressId');
      form.resetField('receiverName');
      form.resetField('receiverPhone');
      form.resetField('receiverPostcode');
      form.resetField('receiverAddress');
      form.resetField('receiverDetailAddress');
      form.resetField('shippingRequest');
    } else {
      form.setValue('newUserAddress.addressName', defaultAddress.addressName);
      form.setValue('userAddressId', defaultAddress.addressId);
      form.setValue('receiverName', defaultAddress.receiverName!);
      form.setValue('receiverPhone', defaultAddress.phone);
      form.setValue('receiverPostcode', defaultAddress.postcode);
      form.setValue(
        'receiverAddress',
        [defaultAddress.sido, defaultAddress.gugun, defaultAddress.address]
          .filter(Boolean)
          .join(' '),
      );
      form.setValue('receiverDetailAddress', defaultAddress.detailAddress);
      form.setValue('shippingRequest', defaultAddress.requestMessage);
    }
  }, [isNewAddress]);

  if (!payInfo) return null;

  const checkRequired =
    form.watch().receiverAddress &&
    form.watch().receiverDetailAddress &&
    form.watch().receiverPhone &&
    form.watch().receiverName;

  const orderStart = (mobileReturnUrl?: string) => {
    const products = payInfo.products;
    var coupon = coupons;
    var sub_total = 0;

    var orderTriedEventProperties = products.map(product => {
      sub_total += product.totalPrice;
      return {
        item_id: String(product.productId),
        item_name: product.productName,
        item_brand: product.brandName,
        item_category: '?',
        item_color: product.color,
        item_gender: '?',
        item_size: product.sizeName,
        item_price: product.initialUnitPrice,
        item_discount_rate: ((product.initialUnitPrice - product.unitPrice) / product.initialUnitPrice) * 100,
        item_discount_price: product.unitPrice,
        order_item_quantity: 0
      };
    }
    );

    var temp = orderTriedEventProperties?.filter((src_item, index, array) => array.findIndex(tmp_item => tmp_item.item_id == src_item.item_id && tmp_item.item_size == src_item.item_size) == index);
    temp?.forEach(src_item => {
      orderTriedEventProperties?.forEach(tmp_item => {
        if (src_item.item_id == tmp_item.item_id && src_item.item_size == tmp_item.item_size) {
          src_item.order_item_quantity++;
        }
      });
    });
    var method = "";
    if (form.watch().payMethod.toString() === "CARD")
      method = "신용카드";
    else
      method = form.watch().payMethod.toString();
    console.log(payInfo);
    Bridge.sendAmplitude('order_tried', {
      non_member_order: isLoggedIn ? false : true,
      item_id: temp?.map((item) => { return item.item_id; }),
      item_name: temp?.map((item) => { return item.item_name; }),
      item_category: temp?.map(() => { return '?'; }),
      item_color: temp?.map((item) => { return item.item_color; }),
      item_gender: temp?.map((item) => { return '?'; }),
      item_size: temp?.map((item) => { return item.item_size; }),
      item_price: temp?.map((item) => { return item.item_price; }),
      item_discount_rate: temp?.map((item) => { return item.item_discount_rate; }),
      item_discount_price: temp?.map((item) => { return item.item_discount_price; }),
      order_item_quantity: temp?.map((item) => { return item.order_item_quantity; }),
      total_order_item_quantity: products.length,
      sub_total: sub_total,
      payment_method: method,
      paid_shipping: payInfo.deliveryPrice,
      paid_point: form.watch().usedMileage,
      coupon_id: coupon.map((item) => { return item.couponId; }),
      coupon_name: coupon.map((item) => { return item.name; }),
      reward_point: payInfo.earnMileageRate * payInfo.totalPrice,
      order_id: String(payInfo.orderNumber),
      order_total: finalPrice
    }
    );

    Bridge.sendBraze(BRAZE_EVENT.ORDER_TRIED, {
      non_member_order: isLoggedIn ? false : true,
      item_id: temp?.map((item) => { return item.item_id; }).join(','),
      item_name: temp?.map((item) => { return item.item_name; }).join(','),
      item_category: temp?.map(() => { return '?'; }).join(','),
      item_color: temp?.map((item) => { return item.item_color; }).join(','),
      item_gender: temp?.map((item) => { return '?'; }).join(','),
      item_size: temp?.map((item) => { return item.item_size; }).join(','),
      item_price: temp?.map((item) => { return item.item_price; }).join(','),
      item_discount_rate: temp?.map((item) => { return item.item_discount_rate; }).join(','),
      item_discount_price: temp?.map((item) => { return item.item_discount_price; }).join(','),
      order_item_quantity: temp?.map((item) => { return item.order_item_quantity; }).join(','),
      total_order_item_quantity: products.length,
      sub_total: sub_total,
      payment_method: method,
      paid_shipping: payInfo.deliveryPrice,
      paid_point: form.watch().usedMileage,
      coupon_id: coupon.map((item) => { return item.couponId; }).join(','),
      coupon_name: coupon.map((item) => { return item.name; }).join(','),
      reward_point: payInfo.earnMileageRate * payInfo.totalPrice,
      order_id: String(payInfo.orderNumber),
      order_total: finalPrice
    }
    );

    if (isNewAddress) {
      form.resetField('userAddressId');
      form.setValue('newUserAddress.receiverName', form.watch().receiverName);
      form.setValue('newUserAddress.phone', form.watch().receiverPhone);
      form.setValue(
        'newUserAddress.detailAddress',
        form.watch().receiverDetailAddress || '',
      );
      form.setValue(
        'newUserAddress.requestMessage',
        form.watch().shippingRequest,
      );
    } else {
      form.resetField('newUserAddress');
    }
    //비회원의 경우 임의의 주소명 필요
    if (!isLoggedIn) {
      form.setValue('newUserAddress.addressName', '');
      localStorage.setItem('customerName', form.watch().customerName);
      localStorage.setItem('customerPhone', form.watch().customerPhone);
    }
    if (checkRequired) {
      if (mobileReturnUrl) form.setValue('mobileReturnUrl', mobileReturnUrl);
      iamportOrderStart(payInfo.orderNumber, form.watch()).then(r =>
        pay(r.data.payload),
      ).catch(e => console.log('orderPaymentStart e: ', e));
      // if (mobileReturnUrl) {
      //   form.setValue('mobileReturnUrl', mobileReturnUrl);
      //   iamportOrderStart(payInfo.orderNumber, form.watch()).then(r => {
      //     history.push('/cart/payment/processing', {
      //       paymentInfo: r.data.payload,
      //       orderInfo: form.watch(),
      //       orderProducts: products,
      //     });
      //   }).catch(e => console.log('orderPaymentStart e: ', e));
      // } else {
      //   iamportOrderStart(payInfo.orderNumber, form.watch()).then(r =>
      //     pay(r.data.payload),
      //   ).catch(e => console.log('orderPaymentStart e: ', e));
      // }
    } else {
      nToast('배송지 정보를 입력해 주세요');
    }

  };

  const pay = (data: PayStartResultV2Dto) => {
    const redirectUrl = `${window.location.protocol + "//" + window.location.host}/cart/payment/success/mobile`;

    // @ts-ignore
    const { IMP } = window;
    IMP.request_pay({
      pg: getPG(form.watch('payMethod')),
      escrow: form.watch('payMethod') === 'TRANSFER',
      kcpProducts: productsGroupAsCartItem().map(product => ({
        "orderNumber": data.orderNumber,
        "name": product.productName,
        "quantity": product.count,
        "amount": product.unitPrice,
      })),
      pay_method: payCode(form.watch('payMethod')),
      merchant_uid: data.orderNumber,
      name: productsGroupAsCartItem()[0].productName,
      amount: data.totalPrice,
      buyer_name: form.watch('customerName'),
      buyer_tel: form.watch('customerPhone'),
      buyer_addr: form.watch('receiverAddress'),
      m_redirect_url: redirectUrl,
      app_scheme: 'carhartt',
      naverPopupMode : !isMobile,
      naverProducts: productsGroupAsCartItem().map(product => ({
        "categoryType": "PRODUCT",
        "categoryId": "GENERAL",
        "uid": product.productId,
        "name": product.productName,
        "count": product.count,
      })),
    }, (rsp: any) => {
      if (rsp.success === true) {
        // 결제 성공 시 로직,
        history.push(`/cart/payment/success?imp_uid=${rsp.imp_uid}&merchant_uid=${rsp.merchant_uid}&imp_success=${rsp.imp_success}`);
      } else {
        // 결제 실패 시 로직,
        alert(`결제에 실패했습니다. ${rsp.error_msg}`);
        window.location.assign('/cart');
      }
    });
  };

  const applyCoupon = (couponCode: string) => {
    const coupon = coupons.find(it => it.couponCode === couponCode);

    if (coupon != undefined && coupon.couponType === 'FREE_SHIPPING') {
      setPayInfo({ ...payInfo, deliveryPrice: 0 });
    } else {
      const productIds = payInfo.products.map(it => it.productId);
      checkCouponProduct(couponCode, productIds).then(r => {
        const couponApplyProductList = r.data.payload;
        console.log(couponApplyProductList);
      }).catch(e => console.log('checkCouponProduct e: ', e));;
    }
  };

  const resetCoupon = () => {
    getOrders().then(r => {
      const data = r.data.payload;
      setPayInfo(data);
      setUsedCouponCode('');
      form.setValue('usedCouponIds', []);
      form.setValue(`usedCouponCode`, '');
      form.setValue('usedMileage', 0);
      form.setValue('payMethod', 'CARD');
    }).catch(e => console.log('getOrders e: ', e));
  };

  const productsGroupAsCartItem = (): OrderProduct[] => {
    const groupedProducts: any = {};
    payInfo.products.forEach(product => {
      console.log(product)
      const { ...dupProduct } = product;
      const compositeKey: string = [dupProduct.productId, dupProduct.sizeName].join('.');
      if (groupedProducts[compositeKey]) {
        groupedProducts[compositeKey].count += 1;
      } else {
        groupedProducts[compositeKey] = dupProduct;
      }
    });

    return Object.values(groupedProducts);
  };

  const finalPrice = couponDiscounted
    ? (couponDiscounted.finalTotalProductsPrice + couponDiscounted.deliveryPrice)
    : payInfo.totalPrice;

  const ProductSection = (
    <>
      <form name="order_info">
        <input type="hidden" name="res_cd" value="" />
        <input type="hidden" name="res_msg" value="" />
        <input type="hidden" name="enc_info" value="" />
        <input type="hidden" name="enc_data" value="" />
        <input type="hidden" name="ret_pay_method" value="" />
        <input type="hidden" name="tran_cd" value="" />
        <input type="hidden" name="use_pay_method" value="" />
        <input type="hidden" name="ordr_chk" value="" />
        <input type="hidden" name="cash_yn" value="" />
        <input type="hidden" name="cash_tr_code" value="" />
        <input type="hidden" name="cash_id_info" value="" />
        <input type="hidden" name="good_expr" value="0" />
        <input type="hidden" name="good_info" value={makeKCPGoodInfo(payInfo?.products, payInfo?.orderNumber)} />

        <input type="hidden" name="escw_used" value="Y" />
        <input type="hidden" name="pay_mod" value="Y" />
        <input type="hidden" name="deli_term" value="3" />
        <input type="hidden" name="bask_cntx" value={`${payInfo.products.length}` || 0} />

        <input type="hidden" name="req_tx" value="pay" />
        <input type="hidden" name="site_name" value="칼하트윕" />
        <input type="hidden" name="site_cd" value={process.env.REACT_APP_SITE_CODE} />
        <input type="hidden" name="ordr_idxx" value="" />
        <input
          type="hidden"
          name="pay_method"
          value={payMethodCode(form.watch().payMethod) || '100000000000'}
        />
        <input type="hidden" name="good_name" value="CARHARTT 상품 구매" />
        <input type="hidden" name="good_mny" value="" />
        <input
          type="hidden"
          name="buyr_name"
          value={form.watch().customerName || ""}
        />
        <input type="hidden" name="buyr_mail" value="" />
        <input
          type="hidden"
          name="buyr_tel1"
          value={form.watch().customerPhone || ""}
        />
        <input
          type="hidden"
          name="buyr_tel2"
          value={form.watch().receiverPhone || ""}
        />
        <input type="hidden" name="shop_user_id" value="" />
        <input type="hidden" name="currency" value="WON" />
        <input type="hidden" name="vcnt_expire_term" value="1" />
      </form>
      <Section className="md:sticky md:top-20 md:w-1/3 md:border md:border-gray-200  divide divide-y md:p-5 space-y-4 h-full">
        <div className="flex space-x-2 items-center">
          <H6 className="">주문 상품</H6>
          <div className="wh-4 bg-gray-200 rounded-full text-12 grid place-content-center font-bold">
            {payInfo.products.length}
          </div>
        </div>

        {productsGroupAsCartItem().map((item, index) => (
          <div
            key={index}
            className="flex space-x-4 font-normal  border-b pt-5">
            <Link to={`/product/${item.productId}`}>
              <div className="w-20 h-24 rounded-md overflow-hidden">
                <img src={item.thumbnailUrl} alt="" className=" object-cover" />
              </div>
            </Link>
            <div className="text-14 text-brand-3 w-full">
              <p className="text-brand-1 font-semibold">{item.productName}</p>
              <p className="whitespace-normal">{item.color}</p>
              <p className="">사이즈 {item.sizeName}</p>
              <p className="">수량 {item.count}개</p>
              {couponDiscounted?.orderProducts[index].unavailableMileage && (
                  <p className="text-13 text-red-500">
                    <p>적립금 사용/적립 불가 상품</p>
                  </p>
              )}
              {couponDiscounted?.orderProducts[index].unavailableCoupon && (
                  <p className="text-13 text-red-500">
                    <p>쿠폰 사용 불가 상품</p>
                  </p>
              )}
              {couponDiscounted ?
                <div className="w-32 float-right">
                  <p className="text-13 text-gray-500 font-normal flex justify-between">
                    <p>
                      {couponDiscounted.orderProducts[index].discountedAmount > 0 &&
                        <>현재가</>
                      }
                    </p>
                    {item.unitPrice.toLocaleString()} 원
                  </p>
                  {couponDiscounted.orderProducts[index].discountedAmount > 0 &&
                    <>
                      <p className={`text-13 EF4444 font-normal flex justify-between`}>
                        <p>쿠폰 할인</p>
                        -
                        {couponDiscounted.orderProducts[
                          index
                        ].discountedAmountByCoupon.toLocaleString()} 원
                      </p>
                      {couponDiscounted.orderProducts[index].discountedAmountByMileage > 0 &&
                        <p className={`text-13 EF4444 font-normal flex justify-between`}>
                          <p>적립금 할인</p>
                          -
                          {couponDiscounted.orderProducts[
                            index
                          ].discountedAmountByMileage.toLocaleString()} 원
                        </p>
                      }
                      <p className={`text-13 text-gray-500 font-normal flex justify-between`}>
                        <p>할인가</p>
                        {couponDiscounted.orderProducts[
                          index
                        ].finalProductPrice.toLocaleString()} 원
                      </p>
                    </>
                  }
                </div>
                :
                <p className="text-right text-13 text-gray-500 font-normal">
                  {item.totalPrice.toLocaleString()} 원
                </p>
              }
            </div>
          </div>
        ))}

        <Section className="pt-5 space-y-2">
          <div className="text-14 flex justify-between">
            <p className="text-gray-500">총 상품금액</p>
            <p className="">
              {couponDiscounted
                ? couponDiscounted.finalTotalProductsPrice
                : (
                  payInfo.totalPrice - payInfo.deliveryPrice
                ).toLocaleString()}{' '}
              원
            </p>
          </div>

          <div className="text-14 flex justify-between">
            <p className="text-gray-500">배송비</p>
            <p className="">
              {couponDiscounted
                ? couponDiscounted.deliveryPrice.toLocaleString()
                : payInfo.deliveryPrice.toLocaleString()}{' '}
              원
            </p>
          </div>

          <div className="text-14 flex justify-between">
            <p className="text-gray-500">총 쿠폰 할인금액</p>
            <p className="">
              -
              {couponDiscounted
                ? couponDiscounted.totalDiscountedAmountByCoupon.toLocaleString()
                : 0}{' '}
              원
            </p>
          </div>

          <div className="text-14 flex justify-between">
            <p className="text-gray-500">총 적립금 할인금액</p>
            <p className="">
              -
              {couponDiscounted
                ? couponDiscounted.totalDiscountedAmountByMileage.toLocaleString()
                : 0}{' '}
              원
            </p>
          </div>

          <div className="text-14 flex justify-between">
            <p className="text-17 font-bold">총 결제금액</p>
            <p className="text-17 font-bold">
              {finalPrice.toLocaleString()}{' '}
              원
            </p>
          </div>

          <div className="text-14 flex justify-between">
            <p className="text-gray-500">적립금 적립 금액</p>
            <p className="">
              {(Math.ceil((
                  (couponDiscounted
                    ? earnedMileage
                    : 0 ) * payInfo.earnMileageRate) / 10) * 10).toLocaleString()
              }
              {' '}원
            </p>
          </div>

        </Section>

        <div className="hidden md:block space-y-2 py-4">
          <Checkbox
            label="주문정보 동의"
            checked={agreement.order}
            onChange={() =>
              setAgreement({ ...agreement, order: !agreement.order })
            }
          />
          <Checkbox
            label="제 3자 제공 동의"
            checked={agreement.third}
            onChange={() =>
              setAgreement({ ...agreement, third: !agreement.third })
            }
          />
        </div>

        {/* PC 결제 */}
        <Button
          disabled={!agreement.order || !agreement.third}
          // to="/my/cart/payment/success"
          text="주문하기"
          className="hidden md:block filled-gray-900 w-full border-none"
          onClick={() => orderStart()}
        />
      </Section>
    </>
  );

  const InfoSection = (
    <>
      <Section className="md:w-3/4 space-y-4 pt-4">
        <H6>주문자 정보</H6>
        <div className="grid md:grid-cols-2 gap-8 pb-6">
          <TextField
            label="이름"
            placeholder="이름을 입력해주세요."
            value={form.watch().customerName || ""}
            {...form.register('customerName')}
          />
          <PhoneNumber
            label="핸드폰 번호"
            value={form.watch().customerPhone || ""}
            onChange={e => form.setValue('customerPhone', e.target.value)}
          />
        </div>

        {/* 배송 정보 section */}
        <div className="flex justify-between items-center">
          <H6 className="font-semibold">배송 정보</H6>

          {isLoggedIn && addresses.length > 0 && (
            <button
              onClick={() => setPopup(true)}
              className="text-13 underline">
              배송지 목록
            </button>
          )}
        </div>
        <div className="grid grid-cols-2 gap-4 md:w-max">
          {isLoggedIn && (
            <>
              {addresses.length > 0 && (
                <Button
                  text="기존 배송지"
                  className={
                    isNewAddress
                      ? 'bg-brand-2 text-gray-900 px-8'
                      : 'filled-brand-1 px-8'
                  }
                  onClick={() => setIsNewAddress(false)}
                />
              )}
              {addresses.length < 5 && (
                <Button
                  text="신규 입력"
                  className={
                    isNewAddress
                      ? 'filled-brand-1 px-8'
                      : 'bg-brand-2 text-gray-900 px-8'
                  }
                  onClick={() => setIsNewAddress(true)}
                />
              )}
            </>
          )}
        </div>
        <div className="grid md:grid-cols-2 gap-x-8 gap-y-5">
          {isLoggedIn && (
            <TextField
              label="배송지명 *"
              placeholder="저장하실 배송지 이름을 적어주세요."
              className=""
              disabled={!isNewAddress}
              {...form.register(`newUserAddress.addressName`)}
            />
          )}
          <TextField
            label="수령인 이름 *"
            placeholder="수령인 이름을 적어주세요."
            className=""
            value={form.watch().receiverName || ""}
            {...form.register('receiverName', { required: true })}
          />
          <PhoneNumber
            label="수취인 전화번호 *"
            value={form.watch().receiverPhone || ""}
            onChange={e => form.setValue('receiverPhone', e.target.value)}
          />
        </div>
        <div className="col-span-2 space-y-2">
          <div className="flex items-end space-x-4">
            <div className="flex-1">
              <TextField
                label="주소 *"
                placeholder="주소"
                disabled={true}
                value={`${form.watch().receiverPostcode || ''} ${form.watch().receiverAddress || ''
                  }`}
              />
            </div>
            <Button
              text="검색"
              className="bg-brand-2 font-bold text-brand-1 text-12 w-20"
              onClick={() => setPostModal(true)}
            />
          </div>
          <TextField
            placeholder="상세 주소 입력"
            value={form.watch().receiverDetailAddress || ""}
            {...form.register('receiverDetailAddress', {
              required: '상세 주소를 입력해 주세요',
            })}
          />
        </div>
        <div className="col-span-2">
          {/*<TextField
            label="배송시 요청사항"
            placeholder="배송시 요청사항을 입력해주세요."
            defaultValue={form.watch().shippingRequest}
            {...form.register('shippingRequest')}
          />*/}
          <Select
            label="배송시 요청사항"
            onChange={e => {
              if (e.target.value !== 'userInput') {
                form.setValue('shippingRequest', e.target.value);
                setShippingRequestUserInput(false);
              } else {
                form.setValue('shippingRequest', '');
                setShippingRequestUserInput(true);
              }
            }
            }
            defaultValue={""}
            className={'border pl-4'}>
            <option disabled hidden value="">배송시 요청사항을 선택해주세요.</option>
            <option>배송전에 미리 연락 바랍니다.</option>
            <option>부재시 경비실에 맡겨 주세요.</option>
            <option>부재시 전화 주시거나 문자 남겨주세요.</option>

            <option value="userInput">직접 입력</option>
          </Select>
          {
            shippingRequestUserInput &&
            <TextField
              placeholder="배송시 요청사항을 입력해주세요."
              className="text-12 h-9 border-gray-400 mt-2"
              {...form.register('shippingRequest')}
            />
          }
        </div>

        {/*  쿠폰 / 적립금 section */}
        {isLoggedIn && (
          <>
            <H6 className="font-semibold">쿠폰 / 적립금</H6>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <Select
                  label="쿠폰 적용"
                  onChange={e => {
                    const type = e.target.value;
                    if (type === 'coupon') {
                      form.setValue(`usedCouponCode`, '');
                      resetCoupon();
                      setCouponPopup(true);
                    } else {
                      resetCoupon();
                      form.setValue(`usedCouponIds`, []);
                    }
                    setDiscountType(e.target.value);
                  }}
                  value={discountType}
                  className={'border pl-4'}>
                  <option value="">
                    선택해주세요.
                  </option>
                  <option value="coupon">쿠폰 선택</option>
                  <option value="code">할인코드 입력</option>
                </Select>

                {discountType === 'code' && (
                  <>
                    <TextField
                      placeholder="코드를 입력해주세요."
                      value={usedCouponCode || ""}
                      onChange={e => setUsedCouponCode(e.target.value)}
                    />
                    <Button
                      text="적용"
                      className="filled-brand-1 px-8"
                      onClick={() => {
                        form.setValue('usedCouponCode', usedCouponCode);
                        // applyCoupon(usedCouponCode);
                      }}
                    />
                  </>
                )}
                {discountType === 'coupon' &&
                  coupons.map((item, index) => {
                    if (
                      form.watch().usedCouponIds.findIndex(i => i === item.id) >
                      -1
                    ) {
                      return (
                        <div
                          className="bg-gray-100 flex justify-between p-3 text-12 items-center"
                          key={index}>
                          <span className="">{item.name}</span>
                          <button
                            onClick={() => {
                              const list = form
                                .watch()
                                .usedCouponIds.filter(i => i !== item.id);
                              list.length === 0 && setDiscountType('')
                              form.setValue(`usedCouponIds`, list);
                              resetCoupon();
                            }}>
                            <Icon.X className={`wh-4`} />
                          </button>
                        </div>
                      );
                    }
                  })}
              </div>

              <div className="hidden md:block" />
              <TextField
                label="적립금"
                placeholder="100원 단위로 사용할 수 있습니다"
                className=""
                type={'number'}
                step={100}
                min={0}
                max={userInfo?.ownPoint || 0}
                value={(form.watch().usedMileage)}
                onChange={e => {
                  let value = parseInt(e.target.value);
                  if (value > userInfo?.ownPoint!) {
                    value = userInfo?.ownPoint!;
                  }
                  if (userInfo?.ownPoint! < 100) {
                    value = 0;
                  }
                  form.setValue('usedMileage', value);
                }}
                onBlur={e => {
                  let point = Math.ceil(parseInt(e.target.value) * 0.01) * 100;
                  if (point > userInfo?.ownPoint!) {
                    point = userInfo?.ownPoint! - 100 > 0 ? Math.ceil((userInfo?.ownPoint! - 100) * 0.01) * 100 : 0;
                  }
                  form.setValue('usedMileage', point);
                }}

              />
              <div className="self-end flex items-center flex-row-reverse md:flex-row space-x-reverse space-x-4 ">
                <button
                  className="bg-brand-2 text-13 font-bold h-12 px-6 "
                  onClick={() => {
                    let point = userInfo?.ownPoint! - 100 > 0 ? Math.ceil((userInfo?.ownPoint! - 100) * 0.01) * 100 : 0;
                    form.setValue('usedMileage', point);
                  }}
                >
                  모두 사용
                </button>
                <p className="text-13 md:pl-4">
                  사용가능 :
                  <span className="font-bold">
                    {' '}
                    {userInfo ? userInfo.ownPoint.toLocaleString() : 0}p
                  </span>
                </p>
              </div>
            </div>
          </>
        )}

        <H6 className="font-semibold">결제수단 선택</H6>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <Button
            text="신용카드"
            className={
              form.watch().payMethod === 'CARD'
                ? 'filled-brand-1'
                : 'outlined-brand-1 text-gray-900'
            }
            onClick={() => form.setValue('payMethod', 'CARD')}
          />
          <Button
            text="에스크로 계좌이체"
            className={
              form.watch().payMethod === 'TRANSFER'
                ? 'filled-brand-1'
                : 'outlined-brand-1 text-gray-900'
            }
            onClick={() => form.setValue('payMethod', 'TRANSFER')}
          />
          <Button
            text="카카오페이"
            className={
              form.watch().payMethod === 'KAKAO'
                ? 'filled-brand-1'
                : 'outlined-brand-1 text-gray-900'
            }
            onClick={() => form.setValue('payMethod', 'KAKAO')}
          />

          {/* TODO: 네이버페이 승인시 살리기 */}
          {/*<Button*/}
          {/*  text="네이버페이"*/}
          {/*  className={*/}
          {/*    form.watch().payMethod === 'NAVER'*/}
          {/*      ? 'filled-brand-1'*/}
          {/*      : 'outlined-brand-1 text-gray-900'*/}
          {/*  }*/}
          {/*  onClick={() => form.setValue('payMethod', 'NAVER')}*/}
          {/*/>*/}

          {/*<Button*/}
          {/*  text="가상계좌"*/}
          {/*  className={*/}
          {/*    form.watch().payMethod === 'VIRTUAL_ACCOUNT'*/}
          {/*      ? 'filled-brand-1 md:px-8'*/}
          {/*      : 'outlined-brand-1 text-gray-900 md:px-8'*/}
          {/*  }*/}
          {/*  onClick={() => form.setValue('payMethod', 'VIRTUAL_ACCOUNT')}*/}
          {/*/>*/}
        </div>
      </Section>
    </>
  );

  return (
    <>
      <CouponPopUp
        open={couponPopup}
        coupons={coupons}
        selectedCouponIds={form.watch().usedCouponIds}
        onSelect={id => {
          // let list = form.watch().usedCouponIds

          // if (list.indexOf(id) > -1) {
          //     list = list.filter((item) => item !== id)
          // } else {
          //     list.push(id)
          //     list.filter((item, index) => list.indexOf(item) === index)
          //     const couponCode = coupons.find(it => it.couponId === id)?.couponCode
          //     if (couponCode !== undefined) {
          //         applyCoupon(couponCode)
          //     }
          // }
          const couponCode = coupons.find(it => it.id === id)?.couponCode;
          couponCode && applyCoupon(couponCode);
          form.setValue(`usedCouponIds`, [id]);
          setCouponPopup(false);
        }}
        onClose={() => {
          setCouponPopup(false);
        }}
      />
      <AddressPopUp
        open={popup}
        onClose={() => setPopup(false)}
        addresses={addresses}
        onSelected={data => {
          setIsNewAddress(false);
          form.resetField('newUserAddress');
          form.setValue('newUserAddress.addressName', data.addressName);
          form.setValue('userAddressId', data.addressId);
          form.setValue('receiverName', data.receiverName!);
          form.setValue('receiverPhone', data.phone);
          form.setValue('receiverPostcode', data.postcode);
          form.setValue(
            'receiverAddress',
            [data.sido, data.gugun, data.address].filter(Boolean).join(' '),
          );
          form.setValue('receiverDetailAddress', data.detailAddress);
          form.setValue('shippingRequest', data.requestMessage);
          setPopup(false);
        }}
      />
      <PostPopUp
        open={postModal}
        onClose={() => setPostModal(false)}
        onSelected={data => {
          if (isNewAddress) {
            form.setValue('newUserAddress.postcode', data.zonecode.toString());
            form.setValue('newUserAddress.sido', data.sido);
            form.setValue('newUserAddress.gugun', data.sigungu);
            form.setValue('newUserAddress.address', data.address.replace(data.sido, '').replace(data.sigungu, '').trim());
          }
          form.setValue('receiverPostcode', data.zonecode.toString());
          form.setValue(
            'receiverAddress', data.address,
          );
          setPostModal(false);
        }}
      />

      <DirectoryBar text="주문 결제" backArrow />

      <div className="flex flex-col-reverse md:flex-row md:space-x-8 md:my-10 max-w-screen-xl mx-auto ">
        {InfoSection}
        {ProductSection}
      </div>

      <div className="md:hidden space-y-2 py-8 ">
        <Checkbox
          label="주문정보 동의"
          checked={agreement.order}
          onChange={() => setAgreement({ ...agreement, order: !agreement.order })}
        />
        <Checkbox
          label="제 3자 제공 동의"
          checked={agreement.third}
          onChange={() => setAgreement({ ...agreement, third: !agreement.third })}
        />
      </div>

      {/* 모바일 결제 */}
      <Button
        disabled={!agreement.order || !agreement.third}
        text="주문하기"
        className="md:hidden filled-brand-1 w-full"
        onClick={() =>
          orderStart(
            `${window.location.protocol + "//" + window.location.host}/cart/payment/success/mobile`,
          )
        }
      />
    </>
  );
};
